import React from 'react';
import PropTypes from 'prop-types';
import './UserViewsTable.scss';
var renderUser = function renderUser(user) {
  var data = [];
  if (user.name) {
    data.push(user.name);
  }
  data.push(user.email);
  return /*#__PURE__*/React.createElement("div", {
    className: "user-name-email"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top medium-weight"
  }, data[0]), data[1] && /*#__PURE__*/React.createElement("div", {
    className: "bottom normal-weight mt-4"
  }, data[1]));
};
var renderView = function renderView(userView) {
  return /*#__PURE__*/React.createElement("tr", {
    className: "user-view-entry",
    key: userView.id,
    id: userView.id
  }, /*#__PURE__*/React.createElement("td", {
    className: "user"
  }, renderUser(userView.user)), /*#__PURE__*/React.createElement("td", {
    className: "view-count"
  }, userView.view_count), /*#__PURE__*/React.createElement("td", {
    className: "last-view"
  }, userView.updated_at));
};
function UserViewsTable(_ref) {
  var userViews = _ref.userViews,
    _ref$userHeader = _ref.userHeader,
    userHeader = _ref$userHeader === void 0 ? 'User' : _ref$userHeader;
  return /*#__PURE__*/React.createElement("div", {
    className: "user-views-panel style-guide box-shadow-1"
  }, /*#__PURE__*/React.createElement("h3", null, "Activity & Views"), /*#__PURE__*/React.createElement("table", {
    className: "user-views-table mt-18"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, userHeader), /*#__PURE__*/React.createElement("th", null, "Views"), /*#__PURE__*/React.createElement("th", null, "Last View")), /*#__PURE__*/React.createElement("tbody", null, userViews.map(function (userView) {
    return renderView(userView);
  }))));
}
UserViewsTable.propTypes = {
  userViews: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userHeader: PropTypes.string
};
UserViewsTable.defaultProps = {
  userHeader: 'User'
};
export default UserViewsTable;